import { render } from "./swipeCardModel.vue?vue&type=template&id=fb990958"
import script from "./swipeCardModel.vue?vue&type=script&lang=js"
export * from "./swipeCardModel.vue?vue&type=script&lang=js"

import "./swipeCardModel.vue?vue&type=style&index=0&id=fb990958&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__